// extracted by mini-css-extract-plugin
export default {"container":"tenantPermissionGroups_container__1maAT"};